module.exports = __webpack_public_path__ + "static/media/us-founders-club-2.0.38461b82.pdf";